<div class="header-container">
  <div class="logo-container">
    <a *ngIf="logged"
      href="/pages/homepage"
      class="sidebar-toggle"
      matRipple
      [matRippleUnbounded]="true"
      [matRippleCentered]="true"
      (click)="toggleSidebar()"
    >
      <nb-icon [icon]="(materialTheme$ | async) ? 'menu-outline' : 'menu-2-outline'"></nb-icon>
    </a>
    <a class="logo" href="/pages/homepage"><img src="assets/images/Logo_ANM_Comunica.png" width="100%"/></a>
  </div>
</div>

<div class="header-container">
  <nb-actions size="small" *ngIf="logged">

    <nb-action
      class="user-action"
      *nbIsGranted="['view', 'user']"
      matRipple
      [matRippleUnbounded]="true"
      [matRippleCentered]="true">
      <nb-user
        [nbContextMenu]="userMenu"
        [onlyPicture]="userPictureOnly"
        [name]="user?.name"
        [picture]="user?.picture">
      </nb-user>
    </nb-action>

  </nb-actions>
</div>
